<template>

    <div class="search-container" v-wechat-title="'mysread'">

        <vue-element-loading :active="isRequest" :is-full-screen="true" spinner="bar-fade-scale" color="#FF6700" />

        <!--頂部欄-->
        <div class="top-nav-container top-container">
            <span @click="backClick" style="margin-left: 10px">返回</span>
            <input v-model="searchText" placeholder="請輸入要搜索的書籍" />
            <span @click="searchBook" style="position: absolute;right: 10px">搜索</span>
        </div>

        <!--推薦書籍-->
        <div v-if="!isStartSearch" class="recommend-container">
            <span style="color: #ea477b;font-size: 16px;font-weight: bold">大家都在看</span>
            <ul>
                <li v-for="book in recommendBookList">
                    <div @click="getBookDetail(book.id)">
                        <a><span>{{book.title}}</span></a>
                    </div>
                </li>
            </ul>
        </div>

        <!--搜索書籍-->
        <div v-if="isStartSearch" class="bookListContainer">
            <ul>
                <li v-for="book in searchBookList">
                    <div @click="getBookDetail(book.id)">
                        <img :src="book.pic1" alt="">
                        <span style="color: black;top: 10%;font-weight: bold">{{book.title}}</span>
                        <span style="top: 25%;color: #999999">作者：{{book.author}}</span>
                        <span style="top: 40%;color: #333333" class="book-dis">{{book.content}}</span>
                    </div>
                </li>
            </ul>
        </div>

    </div>

</template>

<script>
import axios from "axios";

export default {
    name: "SearchVue",
    data() {
        return {
            recommendBookList: [],
            isStartSearch: false,
            searchBookList: [],
            searchText: "",
            isRequest: false,
            isCreate: false,
        };
    },
    methods: {
        //返回
        backClick: function () {
            this.searchText = "";
            this.$router.push({
                path: "SelectedVue",
            });
        },

        //推薦
        recommendBook: function () {
            this.isRequest = true;
            const params = new URLSearchParams();
            params.append("language", "zh-Hant");
            params.append("dev", "h5");
            params.append("uuid", "123456");
            params.append("ver", "1.0");
            params.append("ac", "getSearchDefault");
            this.$http.post(axios.baseURL, params).then((res) => {
                this.isRequest = false;
                if (res.data.status) {
                    this.recommendBookList = res.data.data;
                } else {
                    alert(res.data.msg);
                }
            });
        },

        //搜索
        searchBook: function () {
            if (this.searchText === "") {
                alert("請輸入搜索內容");
                return;
            }
            this.isRequest = true;
            const params = new URLSearchParams();
            params.append("language", "zh-Hant");
            params.append("dev", "h5");
            params.append("uuid", "123456");
            params.append("ver", "1.0");
            params.append("ac", "selectBook");
            params.append("page", "1");
            params.append("keywords", this.searchText);
            this.$http.post(axios.baseURL, params).then((res) => {
                this.isRequest = false;
                if (res.data.status) {
                    this.isStartSearch = true;
                    this.searchBookList = res.data.data;
                } else {
                    alert(res.data.msg);
                }
            });
        },

        //獲取書籍詳情
        getBookDetail: function (bookId) {
            this.$router.push({
                path: "BookDetailVue",
                query: {
                    bookId: bookId,
                    vueName: "SearchVue",
                },
            });
        },
    },

    created() {
        this.isCreate = true;
        this.recommendBook();
    },

    beforeRouteEnter(to, from, next) {
        to.meta.isBack = from.name === "BookDetailVue";
        next();
    },

    activated() {
        // 如果isBack是false 、isCreate也為false，表明需要獲取新數據
        if (!this.$route.meta.isBack && !this.isCreate) {
            //防止進入頁面重新獲取數據的時候還是在之前進入頁面的位置
            window.scrollTo(0, -1);
            this.isStartSearch = false;
            this.recommendBook();
        } else {
            this.isStartSearch = true;
        }
        // 恢復成默認的false，避免isBack壹直是true，導致下次無法獲取數據
        this.$route.meta.isBack = false;
        //重置isCreate為false ,避免isCreate壹直是true，導致下次無法獲取數據
        this.isCreate = false;
    },
};
</script>

<style scoped>
.search-container {
    max-width: 480px;
    min-height: calc(100vh);
    margin: 0 auto;
    border: 1px solid lightgoldenrodyellow;
    background-color: white;
}

.top-container {
    position: fixed;
    top: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.top-container span {
    font-size: 16px;
}

.top-container input {
    width: 60%;
    height: 60%;
    border-radius: 5px;
    margin-left: 9%;
    border: 1px solid #fc9504;
    font-size: 16px;
    padding-left: 10px;
}

.recommend-container {
    margin-top: 70px;
    text-align: left;
    padding-left: 10px;
    padding-right: 10px;
}

.recommend-container ul {
    text-align: left;
    padding-inline-start: 0;
}

.recommend-container ul li {
    line-height: 40px;
    list-style: none;
    border-bottom: 1px solid whitesmoke;
}

.recommend-container ul li a {
    font-size: 14px;
    cursor: pointer;
    text-decoration: none;
    color: #666666;
}

.recommend-container ul li a :active {
    color: #999999;
}

.bookListContainer {
    margin-top: 50px;
    overflow-x: hidden;
}

.bookListContainer ul {
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline-start: 0;
    text-align: left;
}

.bookListContainer ul li {
    list-style: none;
    border-bottom: 1px solid gainsboro;
    position: relative;
    padding: 10px;
}

.bookListContainer ul li img {
    width: 20%;
}

.bookListContainer ul li span {
    width: 70%;
    position: absolute;
    margin-left: 22%;
    font-size: 14px;
    color: #999999;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
}

.book-dis {
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    line-clamp: 3;
    line-height: 20px;
    height: 60px;
    white-space: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchVue.vue